import { Pipe, PipeTransform } from '@angular/core';
import { BillOfMaterialsItem } from '../models/order-dto';

@Pipe({ name: 'billOfMaterialsProgress', })
export class BillOfMaterialsProgressPipe implements PipeTransform {

  transform(bom: BillOfMaterialsItem[]): string {
    const total = bom.length;
    const availableItems = bom.reduce((count, item) => count + (item.isAvailable ? 1 : 0), 0);

    return availableItems + '/' + total;
  }

}
